<div [ngClass]="isHideElement() ? 'slim-container-fluid' : 'container-fluid'">
    <lib-login *ngIf="!authService.isConsoleLoggedIn()" [deviceConfiguration]="deviceConfiguration"></lib-login>
    <lib-desk *ngIf="authService.isConsoleLoggedIn()" [deviceConfiguration]="deviceConfiguration"></lib-desk>
</div>